module.exports = __webpack_public_path__ + "img/HierNochEinZopf.37914b46.jpg";